import React, { useCallback } from "react";

import { sort } from "../../../../Engine/ActionCreators/AllActionCreators";
import { PathResolver, withResolvePaths } from "../../../withResolvePaths";
import { DataType, SortDataType, SortType } from "../../MultiLine/MultiLineTypes";
import { AbsoluteModelPath } from "../../../../../../Common/ModelPath/ModelPath";
import { useTypedDispatch } from "../../../../../../Common/UseTypedSelector";
import { BindingPath } from "../../../../Engine/Core/CoreTypes";
import { useMultilineClient } from "../../../../Engine/Core/Filtering/UseMultilineClient";

import { SortRadioGroup, SortRadioGroupProps } from "./SortRadioGroup";

interface SortRadioGroupOwnProps extends Omit<Omit<SortRadioGroupProps, "filteredUniqKey">, "dataType"> {
    items: [SortType, string];
    multilinePath: AbsoluteModelPath;
    dataPath: AbsoluteModelPath;
    dataType?: SortDataType;
    dataSave: boolean;
    filteredUniqKey?: string;
    resolvePath: PathResolver;
}

const SortRadioGroupContainerBase: React.FC<SortRadioGroupOwnProps> = ownProps => {
    const { items, multilinePath, dataPath, dataType, dataSave, filteredUniqKey = "default", resolvePath } = ownProps;
    const dispatch = useTypedDispatch();
    const resolvedMultilinePath = resolvePath(multilinePath);

    const { client, multilineSort } = useMultilineClient(resolvedMultilinePath, filteredUniqKey, info => ({
        client: info.client,
        multilineSort: info.multilineState.sorting,
    }));

    const value =
        multilineSort == undefined || multilineSort.dataPath !== resolvePath(dataPath).toLegacyPath()
            ? undefined
            : multilineSort.value;

    const handleSort = useCallback(
        (_stickyTablePath: BindingPath, currentValue: SortType) => {
            dispatch(
                sort(
                    resolvedMultilinePath.toLegacyPath(),
                    resolvePath(dataPath).toLegacyPath(),
                    dataType || DataType.Number,
                    dataSave,
                    currentValue,
                    client
                )
            );
        },
        [dispatch, resolvePath, multilinePath, dataPath, dataType, dataSave, filteredUniqKey]
    );

    return <SortRadioGroup {...ownProps} items={items} value={value} sort={handleSort} />;
};

export const SortRadioGroupContainer = withResolvePaths(SortRadioGroupContainerBase);
